import Utils from '@/common/utils/utils';
import Storage from '@/amplify/storage';

/**
 * uploadFileToS3
 * @param {*} filePath
 * @param {*} fileUpload
 * @returns
 */
export const uploadFileToS3 = async (filePath, fileUpload) => {
    try {
        if (!fileUpload || !fileUpload.file || Utils.isEmptyObject(fileUpload.file)) {
            return false;
        }
        if (!filePath) {
            filePath = fileUpload.key;
        }
        const file = fileUpload.file;
        let result = await Storage.put(filePath, file, {
            contentType: file.type,
            level: 'public'
        });

        return result;
    } catch (error) {
        console.log('uploadFileToS3: Exception - ', error);
        return false;
    }
};

export const uploadFileHtmlToS3 = async (filePath, fileContent = '') => {
    try {
        if (!filePath) {
            return false;
        }
        const file = new Blob([fileContent], { type: 'text/html' });
        let result = await Storage.put(filePath, file, {
            contentType: file.type,
            level: 'public'
        });

        return result;
    } catch (error) {
        console.log('uploadFileHtmlToS3 error', error);
        return false;
    }
}

export const uploadFileScriptToS3 = async (filePath, fileContent = '', contentType = 'application/javascript') => {
    try {
        if (!filePath) {
            return false;
        }
        const file = new Blob([fileContent], { type: contentType });
        let result = await Storage.put(filePath, file, {
            contentType: file.type,
            level: 'public'
        });

        return result;
    } catch (error) {
        console.log('uploadFileScriptToS3 error', error);
        return false;
    }
}

export const uploadFileToS3WithContentType = async (filePath, fileContent = '', contentType = 'application/javascript') => {
    try {
        if (!filePath) {
            return false;
        }
        const file = new Blob([fileContent], { type: contentType });
        let result = await Storage.put(filePath, file, {
            contentType: file.type,
            level: 'public'
        });

        return result;
    } catch (error) {
        console.log('uploadFileToS3WithContentType error', error);
        return false;
    }
}
